import { render, staticRenderFns } from "./distributorStoreStat.vue?vue&type=template&id=ffe8b7fe&scoped=true&"
import script from "./distributorStoreStat.vue?vue&type=script&lang=js&"
export * from "./distributorStoreStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe8b7fe",
  null
  
)

export default component.exports